/**
 * Created by renzo on 09.05.17.
 */
/**
 * Created by christiancueni on 12/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { CustomAction } from '../actions/CustomAction';
import { Notification } from './notifications.models';
import { type } from '../shared/util';

export const NotificationsActionTypes = {
  NOTIFICATIONS_GET_NOTIFICATIONS: type("[Notification] Get Notification"),
  NOTIFICATIONS_GET_NOTIFICATIONS_SUCCESS: type("[Notification] Get Notifications Success"),
  NOTIFICATIONS_GET_NOTIFICATIONS_FAIL: type("[Notification] Get Notifications Fail"),
  NOTIFICATIONS_MARK_NOTIFICATIONS: type("[Notification] Mark Notifications"),
  NOTIFICATIONS_MARK_NOTIFICATIONS_SUCCESS: type("[Notification] Mark Notifications Success"),
  NOTIFICATIONS_MARK_NOTIFICATIONS_FAIL: type("[Notification] Mark Notifications Fail"),
  NOTIFICATIONS_START_INTVERVAL: type("[Notification] Start Interval"),
  NOTIFICATIONS_CLEAR_INTVERVAL: type("[Notification] Clear Interval"),
  NOTIFICATIONS_UNSET_NEW_NOTIFICATIONS: type("[Notification] Unset new notifications"),
  NOTIFICATIONS_SET_LATEST_ID: type("[Notification] Set latest notification ID"),
  NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE: type("[Notification] Get Notification for page"),
  NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE_SUCCESS: type("[Notification] Get Notification for page success"),
  NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE_FAIL: type("[Notification] Get Notification for page fail"),
  NOTIFICATIONS_MARK_All_NOTIFICATIONS: type("[Notification] Mark All Notifications"),
  NOTIFICATIONS_MARK_All_NOTIFICATIONS_SUCCESS: type("[Notification] Mark All Notifications Success"),
  NOTIFICATIONS_MARK_All_NOTIFICATIONS_FAIL: type("[Notification] Mark All Notifications Fail"),
  NOTIFICATIONS_SET_ERROR: type("[Notification] Set Notification Error"),
  NOTIFICATIONS_SET_TO_LATEST_ID: type("[Notification] Set to lastest Notification ID"),
  NOTIFICATIONS_GET_OFFLINE_NOTIFICATIONS_FOR_PAGE: type("[Notification] Get Offline Notifications for page"),
  NOTIFICATIONS_RESET: type("[Notification] Reset")
};

export class GetNotifications implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS;

    constructor(public payload: number) { }
}

export class GetNotificationsSuccess implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_SUCCESS;

    constructor(public payload: Notification[]) { }
}

export class GetNotificationsFail implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FAIL;

    constructor(public payload: Object) { }
}

export class MarkNotifications implements CustomAction {
readonly type = NotificationsActionTypes.NOTIFICATIONS_MARK_NOTIFICATIONS;

  constructor(public payload: number) { }
}

export class MarkNotificationsSuccess implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_MARK_NOTIFICATIONS_SUCCESS;

    constructor() { }
}

export class MarkNotificationsFail implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_MARK_NOTIFICATIONS_FAIL;

    constructor(public payload: Object) { }
}

export class StartInterval implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_START_INTVERVAL;

    constructor() { }
}

export class ClearInterval implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_CLEAR_INTVERVAL;

    constructor() { }
}

export class UnsetNewNotifications implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_UNSET_NEW_NOTIFICATIONS;

  constructor() { }
}

export class SetLatestNotificationAction implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_SET_LATEST_ID;

    constructor(public payload: number) { }
}

export class GetNotificationsForPage implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE;

    constructor() { }
}

export class GetNotificationsForPageSuccess implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE_SUCCESS;

    constructor(public payload: Notification[]) { }
}

export class GetNotificationsForPageFail implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE_FAIL;

    constructor(public payload: Object) { }
}


export class MarkAllNotificationsAsRead implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_MARK_All_NOTIFICATIONS;

    constructor() { }
}

export class MarkAllNotificationsAsReadSuccess implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_MARK_All_NOTIFICATIONS_SUCCESS;

    constructor() { }
}

export class MarkAllNotificationsAsReadFail implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_MARK_All_NOTIFICATIONS_FAIL;

    constructor(public payload: Object) { }
}

export class SetNotificationErrorAction implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_SET_ERROR;

    constructor(public payload: string) { }
}

export class SetToLatestNotificationId implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_SET_TO_LATEST_ID;

    constructor() { }
}

export class GetNotificationsOfflineForPage implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_GET_OFFLINE_NOTIFICATIONS_FOR_PAGE;

    constructor() { }
}

export class ResetNotificationsAction implements CustomAction {
    readonly type = NotificationsActionTypes.NOTIFICATIONS_RESET;

    constructor() { }
}

export type NotificationsActions =
    GetNotifications |
    GetNotificationsSuccess |
    GetNotificationsFail |
    MarkNotifications |
    MarkNotificationsSuccess |
    MarkNotificationsFail |
    StartInterval |
    ClearInterval |
    UnsetNewNotifications | 
    SetLatestNotificationAction |
    GetNotificationsForPage |
    GetNotificationsForPageSuccess |
    GetNotificationsForPageFail |
    MarkAllNotificationsAsRead |
    SetToLatestNotificationId |
    SetNotificationErrorAction |
    GetNotificationsOfflineForPage |
    ResetNotificationsAction;
